"use strict";

/* eslint-disable indent */
var moment = require('moment');

var React = require('react');

var PropTypes = require('prop-types');

var flattenDeep = require('lodash/flattenDeep');

var Highlight = require('./Highlight');

var copies = require('../../PrintingDetails/componentComposables/qtyText/copies');

var _require = require('../../../products/components'),
    Invitation = _require.Invitation,
    SmallEnclosure = _require.SmallEnclosure,
    LargeEnclosure = _require.LargeEnclosure,
    ResponseCard = _require.ResponseCard,
    MediumWrapper = _require.MediumWrapper,
    EnvelopeLiner = _require.EnvelopeLiner,
    EuroFlapEnvelopeLiner = _require.EuroFlapEnvelopeLiner;

var ResponseCardEnvelope = require('../../../products/components/ResponseCardEnvelope');

var A7Envelope = require('../../../products/components/InvitationEnvelope/A7Envelope');

var A75Envelope = require('../../../products/components/InvitationEnvelope/A75Envelope');

function getPrintingDetailsForPaperType(_ref) {
  var PrintJobs = _ref.PrintJobs,
      paperType = _ref.paperType;
  var today = new Date();
  var date = moment(today).format('MMDDYY');
  var invitations = 0;
  var small_enclosures = 0;
  var large_enclosures = 0;
  var response_cards = 0;
  var envelope_liners = 0;
  var euro_flap_envelope_liners = 0;
  var belly_bands = 0;
  var a1_envelopes = 0;
  var a7_envelopes = 0;
  var a75_envelopes = 0;
  flattenDeep(PrintJobs.map(function (_ref2) {
    var products = _ref2.products;
    return products;
  })).filter(function (_ref3) {
    var product_type = _ref3.product_type;
    return product_type === 'Custom Samples';
  }).forEach(function (product) {
    product.subcomponents().filter(function (_ref4) {
      var paper_type = _ref4.paper_type;
      return paper_type === paperType;
    }).forEach(function (subcomponent) {
      if (subcomponent instanceof Invitation) {
        invitations += 1;
      }

      if (subcomponent instanceof EnvelopeLiner) {
        envelope_liners += 1;
      }

      if (subcomponent instanceof EuroFlapEnvelopeLiner) {
        euro_flap_envelope_liners += 1;
      }

      if (subcomponent instanceof SmallEnclosure) {
        small_enclosures += 1;
      }

      if (subcomponent instanceof LargeEnclosure) {
        large_enclosures += 1;
      }

      if (subcomponent instanceof ResponseCard) {
        response_cards += 1;
      }

      if (subcomponent instanceof MediumWrapper) {
        belly_bands += 1;
      }

      if (subcomponent instanceof ResponseCardEnvelope) {
        a1_envelopes += 1;
      }

      if (subcomponent instanceof A7Envelope) {
        a7_envelopes += 1;
      }

      if (subcomponent instanceof A75Envelope) {
        a75_envelopes += 1;
      }
    });
  });
  return {
    date: date,
    invitations: invitations,
    small_enclosures: small_enclosures,
    large_enclosures: large_enclosures,
    response_cards: response_cards,
    envelope_liners: envelope_liners,
    euro_flap_envelope_liners: euro_flap_envelope_liners,
    belly_bands: belly_bands,
    a1_envelopes: a1_envelopes,
    a7_envelopes: a7_envelopes,
    a75_envelopes: a75_envelopes
  };
}

function WhiteMatte(props) {
  var _getPrintingDetailsFo = getPrintingDetailsForPaperType(props),
      date = _getPrintingDetailsFo.date,
      invitations = _getPrintingDetailsFo.invitations,
      small_enclosures = _getPrintingDetailsFo.small_enclosures,
      large_enclosures = _getPrintingDetailsFo.large_enclosures,
      response_cards = _getPrintingDetailsFo.response_cards,
      envelope_liners = _getPrintingDetailsFo.envelope_liners,
      euro_flap_envelope_liners = _getPrintingDetailsFo.euro_flap_envelope_liners,
      belly_bands = _getPrintingDetailsFo.belly_bands,
      a1_envelopes = _getPrintingDetailsFo.a1_envelopes,
      a7_envelopes = _getPrintingDetailsFo.a7_envelopes,
      a75_envelopes = _getPrintingDetailsFo.a75_envelopes;

  if (!(invitations || small_enclosures || large_enclosures || response_cards || envelope_liners || euro_flap_envelope_liners || belly_bands || a1_envelopes || a7_envelopes || a75_envelopes)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "------------------------MOHAWK ULTRAWHITE------------------------\n\n\n\nFile: ".concat(date, "-CustomSample-WhiteMatte-Invitation-Bleed-VariableData.pdf\nSize: 5x7\"\nQueue: 403 - "), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 28\nOrientation: Portrait\nPaper: Mohawk Ultrawhite 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: invitations,
    up: 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\n\nFile: ").concat(date, "-CustomSample-WhiteMatte-Response-Bleed-VariableData.pdf\nSize: 3.5x4.875\"\nQueue: 406 - "), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 29\nOrientation: Portrait\nPaper: Mohawk Ultrawhite 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: response_cards,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-WhiteMatte-SmallEnclosure-Bleed-VariableData.pdf\nSize: 3.5x3.9375\"\nQueue: 408 - "), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 30\nOrientation: Portrait\nPaper: Mohawk Ultrawhite 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: small_enclosures,
    up: 12,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\n\nFile: ").concat(date, "-CustomSample-WhiteMatte-LargeEnclosure-Bleed-VariableData.pdf\nSize: 3.5x5.8125\"\nQueue: 410 - "), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 38\nOrientation: Portrait\nPaper: Mohawk Ultrawhite 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: large_enclosures,
    up: 6,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n")), /*#__PURE__*/React.createElement(React.Fragment, null, euro_flap_envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteMatte-Euro-Liner-Bleed-VariableData.pdf\nSize: 6.9087x9.2254\"\nQueue: 458 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: Die Cut\nOrientation: Portrait\nPaper: Mohawk Ultrawhite 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: euro_flap_envelope_liners,
    up: 2,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n"))) : null, envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteMatte-Liner-Bleed-VariableData.pdf\nSize: 6.5x5.25\"\nQueue: 416 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: 2\nOrientation: Landscape\nPaper: Mohawk Ultrawhite 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: envelope_liners,
    up: 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n"))) : null), /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteMatte-BellyBand-175Thick-Bleed-VariableData.pdf\nSize: 11x1.75\"\nQueue: 452 - "), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nOrientation: Landscape\nPaper: Mohawk Ultrawhite 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: belly_bands,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n--------------------------------------------------------------------------------\n\nENVELOPES\n\n\n---Mohawk Ultrawhite---\n\nFile: ").concat(date, "-CustomSample-WhiteMatte-InvitationEnvelope-Double-GuestAndReturnAddressing-Outer-A75.pdf\nSize: MOHAWK ULTRAWHITE A75\nQty: ").concat(a75_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP OPEN"), "\n\n\nFile: ".concat(date, "-CustomSample-WhiteMatte-InvitationEnvelope-Double-NamePrinting-Inner-A7.pdf\nSize: MOHAWK ULTRAWHITE A7 UNGUMMED\nQty: ").concat(a7_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n\nFile: ".concat(date, "-CustomSample-WhiteMatte-ResponseEnvelope-ReturnAddressing-A1.pdf\nSize: MOHAWK ULTRAWHITE A1\nQty: ").concat(a1_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n\n", " "));
}

function IvoryMatte(props) {
  var _getPrintingDetailsFo2 = getPrintingDetailsForPaperType(props),
      date = _getPrintingDetailsFo2.date,
      invitations = _getPrintingDetailsFo2.invitations,
      small_enclosures = _getPrintingDetailsFo2.small_enclosures,
      large_enclosures = _getPrintingDetailsFo2.large_enclosures,
      response_cards = _getPrintingDetailsFo2.response_cards,
      envelope_liners = _getPrintingDetailsFo2.envelope_liners,
      euro_flap_envelope_liners = _getPrintingDetailsFo2.euro_flap_envelope_liners,
      belly_bands = _getPrintingDetailsFo2.belly_bands,
      a1_envelopes = _getPrintingDetailsFo2.a1_envelopes,
      a7_envelopes = _getPrintingDetailsFo2.a7_envelopes,
      a75_envelopes = _getPrintingDetailsFo2.a75_envelopes;

  if (!(invitations || small_enclosures || large_enclosures || response_cards || envelope_liners || euro_flap_envelope_liners || belly_bands || a1_envelopes || a7_envelopes || a75_envelopes)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "-----------------------MOHAWK IVORY------------------------\n\n\n\nFile: ".concat(date, "-CustomSample-IvoryMatte-Invitation-Bleed-VariableData.pdf\n\nSize: 5x7\"\n\nQueue: 403 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\n\nCut Code: 28\n\nOrientation: Portrait\n\nPaper: Mohawk Ivory 130lb Cover\n\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: invitations,
    up: 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-IvoryMatte-Response-Bleed-VariableData.pdf\nSize: 3.5x4.875\"\nQueue: 406 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 29\nOrientation: Portrait\nPaper: Mohawk Ivory 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: response_cards,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-IvoryMatte-SmallEnclosure-Bleed-VariableData.pdf\nSize: 3.5x3.9375\"\nQueue: 408 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 30\nOrientation: Portrait\nPaper: Mohawk Ivory 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: small_enclosures,
    up: 12,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-IvoryMatte-LargeEnclosure-Bleed-VariableData.pdf\nSize: 3.5x5.8125\"\nQueue: 410 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 38\nOrientation: Portrait\nPaper: Mohawk Ivory 130lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: large_enclosures,
    up: 6,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n")), /*#__PURE__*/React.createElement(React.Fragment, null, euro_flap_envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-IvoryMatte-Euro-Liner-Bleed-VariableData.pdf\nSize: 6.9087x9.2254\"\nQueue: 458 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: Die Cut\nOrientation: Portrait\nPaper: Mohawk Ivory 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: euro_flap_envelope_liners || envelope_liners,
    up: euro_flap_envelope_liners ? 2 : 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {})))) : null), /*#__PURE__*/React.createElement(React.Fragment, null, envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-IvoryMatte-Liner-Bleed-VariableData.pdf\nSize: 6.5x5.25\"\nQueue: 416 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: 2\nOrientation: Landscape\nPaper: Mohawk Ivory 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: euro_flap_envelope_liners || envelope_liners,
    up: euro_flap_envelope_liners ? 2 : 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {})))) : null), /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-IvoryMatte-BellyBand-175Thick-Bleed-VariableData.pdf\nSize: 11x1.75\"\nQueue: 452 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nOrientation: Landscape\nPaper: Mohawk Ivory 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: belly_bands,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n--------------------------------------------------------------------------------\n\nENVELOPES\n\n---Mohawk Ivory---\n\n\nFile: ").concat(date, "-CustomSample-IvoryMatte-InvitationEnvelope-Double-GuestAndReturnAddressing-Outer-A75.pdf\nSize: MOHAWK IVORY A75\nQty: ").concat(a75_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP OPEN"), "\n\n\nFile: ".concat(date, "-CustomSample-IvoryMatte-InvitationEnvelope-Double-NamePrinting-Inner-A7.pdf\nSize: MOHAWK IVORY A7 UNGUMMED\nQty: ").concat(a7_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n\nFile: ".concat(date, "-CustomSample-IvoryMatte-ResponseEnvelope-ReturnAddressing-A1.pdf\nSize: MOHAWK IVORY A1\nQty: ").concat(a1_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n\n"));
}

function WhiteShimmer(props) {
  var _getPrintingDetailsFo3 = getPrintingDetailsForPaperType(props),
      date = _getPrintingDetailsFo3.date,
      invitations = _getPrintingDetailsFo3.invitations,
      small_enclosures = _getPrintingDetailsFo3.small_enclosures,
      large_enclosures = _getPrintingDetailsFo3.large_enclosures,
      response_cards = _getPrintingDetailsFo3.response_cards,
      envelope_liners = _getPrintingDetailsFo3.envelope_liners,
      euro_flap_envelope_liners = _getPrintingDetailsFo3.euro_flap_envelope_liners,
      belly_bands = _getPrintingDetailsFo3.belly_bands,
      a1_envelopes = _getPrintingDetailsFo3.a1_envelopes,
      a7_envelopes = _getPrintingDetailsFo3.a7_envelopes,
      a75_envelopes = _getPrintingDetailsFo3.a75_envelopes;

  if (!(invitations || small_enclosures || large_enclosures || response_cards || envelope_liners || belly_bands || a1_envelopes || a7_envelopes || a75_envelopes)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "------------------------SHINE PEARL------------------------\n\n\nFile: ".concat(date, "-CustomSample-WhiteShimmer-Invitation-Bleed-VariableData.pdf\nSize: 5x7\"\nQueue: 203 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 28\nOrientation: Portrait\nPaper: Shine Pearl 137lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: invitations,
    up: 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-WhiteShimmer-Response-Bleed-VariableData.pdf\nSize: 3.5x4.875\"\nQueue: 206 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 29\nOrientation: Portrait\nPaper: Shine Pearl 137lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: response_cards,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-WhiteShimmer-SmallEnclosure-Bleed-VariableData.pdf\nSize: 3.5x3.9375\"\nQueue: 208 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 30\nOrientation: Portrait\nPaper: Shine Pearl 137lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: small_enclosures,
    up: 12,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n\nFile: ").concat(date, "-CustomSample-WhiteShimmer-LargeEnclosure-Bleed-VariableData.pdf\nSize: 3.5x5.8125\"\nQueue: 210 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nCut Code: 38\nOrientation: Portrait\nPaper: Shine Pearl 137lb Cover\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: large_enclosures,
    up: 6,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n")), /*#__PURE__*/React.createElement(React.Fragment, null, euro_flap_envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteShimmer-Euro-Liner-Bleed-VariableData.pdf\nSize: 6.9087x9.2254\"\nQueue: 258 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: Die Cut\nOrientation: Portrait\nPaper: Shine Pearl 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: euro_flap_envelope_liners || envelope_liners,
    up: euro_flap_envelope_liners ? 2 : 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n"))) : null, envelope_liners ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteShimmer-Liner-Bleed-VariableData.pdf\nSize: 6.5x5.25\"\nQueue: 216 - ")), /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), /*#__PURE__*/React.createElement("span", null, "\nCut Code: 2\nOrientation: Landscape\nPaper: Shine Pearl 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: euro_flap_envelope_liners || envelope_liners,
    up: euro_flap_envelope_liners ? 2 : 4,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n"))) : null), /*#__PURE__*/React.createElement("span", null, "\nFile: ".concat(date, "-CustomSample-WhiteShimmer-BellyBand-175Thick-Bleed-VariableData.pdf\nSize: 11x1.75\"\nQueue: 252 - "), " ", /*#__PURE__*/React.createElement(Highlight, null, "CHANGE IMPOSITION TO UNIQUE"), "\nOrientation: Landscape\nPaper: Shine Pearl 80lb Text\nQty: ".concat(copies(undefined, undefined, undefined, {
    quantity: belly_bands,
    up: 9,
    bleed: 'b',
    has_variable_data: true
  }, undefined, {}), "\n\n--------------------------------------------------------------------------------\n\nENVELOPES\n\n\n---Shine Pearl---\n\nFile: ").concat(date, "-CustomSample-WhiteShimmer-InvitationEnvelope-Double-GuestAndReturnAddressing-Outer-A75.pdf\nSize: SHINE PEARL A75\nQty: ").concat(a75_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP OPEN"), "\n\n\nFile: ".concat(date, "-CustomSample-WhiteShimmer-InvitationEnvelope-Double-NamePrinting-Inner-A7.pdf\nSize:SHINE PEARL A7 UNGUMMED\nQty: ").concat(a7_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n\nFile: ".concat(date, "-CustomSample-WhiteShimmer-ResponseEnvelope-ReturnAddressing-A1.pdf\nSize: SHINE PEARL A1\nQty: ").concat(a1_envelopes, "\n"), /*#__PURE__*/React.createElement(Highlight, null, "Note: PRINT FLAP CLOSED"), "\n\n"));
}

function CustomSamplesByPaperType(props) {
  var paperType = props.paperType;

  switch (paperType) {
    case 'White Matte':
      return /*#__PURE__*/React.createElement(WhiteMatte, props);

    case 'Ivory Matte':
      return /*#__PURE__*/React.createElement(IvoryMatte, props);

    case 'White Shimmer':
      return /*#__PURE__*/React.createElement(WhiteShimmer, props);

    default:
      return null;
  }
}

CustomSamplesByPaperType.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  paperType: PropTypes.string.isRequired
};
WhiteMatte.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  paperType: PropTypes.string.isRequired
};
IvoryMatte.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  paperType: PropTypes.string.isRequired
};
WhiteShimmer.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  paperType: PropTypes.string.isRequired
};
module.exports = CustomSamplesByPaperType;